import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { ThemeSettingService } from '../services/theme-setting.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { Action } from '../objects/DetailObject';

@Component({
  selector: 'app-modal-control',
  templateUrl: './modal-control.component.html',
  styleUrls: ['./modal-control.component.css']
})
export class ModalControlComponent implements OnInit {
  
  @HostListener("document:keydown", ["$event"])
  handleKeyup(event) {
    if (event.keyCode === 8 && event.target.tagName.toUpperCase() != "INPUT" && event.target.tagName.toUpperCase() != "TEXTAREA") {
      event.preventDefault();
    }
  }

  isBusy: boolean = false;
  loaderConfig: any;
  modalRef: BsModalRef;
  title:string;
  popupTitle: string;
  type: string;
  actions: Action[] = [];
  currentAction: any;
  expandSummary: boolean = false;

  @Output() subSelectedId = new EventEmitter<string>();

  constructor(private themeSettingService: ThemeSettingService, public bsModalRef: BsModalRef | null, private modalService: BsModalService) { }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
  }

  hide(): void {
    this.bsModalRef.hide();
  }

  onSelected($event){
    this.openPopup($event, "");
  }

  setActions(actions: Action[]){
    this.actions = actions;
  }
  
  openPopup(event, title: string) {
    const config: ModalOptions = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-detail',
      initialState: {
        componentId: event,
        title: title
      }
    };

    if (this.modalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
    }

    this.modalService.onHide.subscribe((reason: string) => {
      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
      }
    })

    this.modalRef = this.modalService.show(DetailPopupComponent, config);
  }

  setCurrentAction(action:Action){
    if (this.currentAction){
      if (this.currentAction.ActionName == action.ActionName){
        this.currentAction = null;
        setTimeout(() => {
          this.currentAction = action;
        })
      }
      else{
        this.currentAction = action;
      }
    }
    else{
      this.currentAction = action;
    }
  }

  handleLoading(event){
    this.isBusy = event;
  }
}
